import { Component } from "@angular/core";
import { GlobalApp, AuthorizationStatus } from "../../tools/global";
import {
  AccountService,
  InteractivesService,
  SubscriptionService,
  AdminInteractiveService,
  InteractSubTypesService,
  AdminInteractiveSubService,
  SubPeriodTypesService,
  AdminXmlaSubscriptionService, SettingsService,
} from "../../api/services";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router, ActivatedRoute } from "@angular/router";
import {
  DropDownItem,
  ManagedSubscription,
  InteractSubTypes,
  InteractSubLevels,
  SubPeriodTypes,
  InteractSubType,
  InteractSubPrice,
  XmlaSubscriptionType,
  XmlaSubscriptionLevelEx,
  XmlaSubscriptionPriceEx,
  XmlaSubscriptionTypeEx,
  XmlaSubscriptionPrice,
  SubscriptionPurchaseViewModel,
  Users,
} from "../../api/models";
import { LoginLocal } from "../../api/models/login-local";
import { Observable, interval, observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { MessageDialogComponent } from "../../dialogs/message-dialog/message-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { HtmlMessageDialogComponent } from "../../dialogs/html-message-dialog/html-message-dialog.component";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-home",
  templateUrl: "./purchase-subscription.component.html",
  styleUrls: ["./purchase-subscription.component.css"],
})
export class PurchaseSubscriptionComponent {
  doneLoading: boolean = false;

  subscriptionType: string = "Loading Subscription, Please Wait...";
  subscriptionPlanId: number = 0;
  subscriptionPlanName: string = '';
  subscriptionLevelId: number = 0;
  subscriptionLevelName: string = '';
  subscriptionPeriodId: number = 0;
  subscriptionPeriodName: string = '';
  organizationName: string = "";
  userEmail: string = "";
  reEnterUserEmail: string = "";
  title: string = "";
  firstName: string = "";
  lastName: string = "";
  addressLine1: string = "";
  addressLine2: string = "";
  city: string = "";
  state: string = "";
  zip: string = "";
  phone: string = "";
  purchaserEmail: string = "";
  reEnterPurchaserEmail: string = "";
  purchaserPhone: string = "";
  purchaserFirstName: string = "";
  purchaserLastName: string = "";
  purchaserAddress1: string = "";
  purchaserAddress2: string = "";
  purchaserCity: string = "";
  purchaserState: string = "";
  purchaserZip: string = "";
  purchaserTitle: string = "";
  purchaserOrganizationName: string = "";
  licenseAgree: boolean = false;
  couponCode: string = "";
  taxExempt: string = "";
  taxExemptNumber: string = "";
  taxExemptExpirationDate: string = "";
  orderPrice: number = 0;
  orderDiscount: number = 0;
  orderSalesTax: number = 0;
  orderTotalDue: number = 0;
  orderPaymentMethod: string = "CreditCard";
  poNumber: string = "";
  autoRenew: boolean = true;
  ccNumber: string = "";
  ccExpirationMonth: string = "";
  ccExpirationYear: string = "";
  ccCvv: number = 0;
  password: string = "";
  confirmPassword: string = "";

  licenseHtml: string = "";

  allInteractSubTypes: InteractSubType[] = [];
  allInteractSubLevels: InteractSubLevels[] = [];
  allInteractPricesTypes: InteractSubPrice[] = [];
  allPeriodTypes: SubPeriodTypes[] = [];

  selectedSubLevels: InteractSubLevels[] = [];
  selectedPriceTypes: InteractSubPrice[] = [];

  allXmlaSubTypes: XmlaSubscriptionTypeEx[] = [];
  allXmlaSubLevels: XmlaSubscriptionLevelEx[] = [];
  allXmlaSubPrices: XmlaSubscriptionPriceEx[] = [];

  selectedXmlaSubLevels: XmlaSubscriptionLevelEx[] = [];
  selectedXmlaSubPrices: XmlaSubscriptionPriceEx[] = [];

  couponCodeError: string = "";

  purchaseType: string = "I";

  loginErrorMessage: string = "";

  resendFlag: boolean = false;

  userIsBuyer: boolean = true;
  nonConsumer: boolean = false;

  donePurchasing: boolean = false;
  allowInvoice: boolean = true;

  isFreeTrial: boolean = false;

  authStatus: AuthorizationStatus = {
    isValid: false,
    userId: "",
    authToken: "",
    isAdmin: false,
  };

  isExistingUser: boolean = false;
  isExistingPurchaser: boolean = false;

  processingCreditCard: boolean = false;
  payPalUrl: SafeResourceUrl = null;

  ccAvailableMonths: string[] = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  ccAvailableYears: string[] = [];

  isProposal: boolean = false;
  isTaxable: boolean = false;
  taxRate: number = 0;
  tosUrl: string = '';
  baseTosUrl: string = '';

  constructor(
    private app: GlobalApp,
    private subscriptionService: SubscriptionService,
    private snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private adminInteractiveSubService: AdminInteractiveSubService,
    private subPeriodTypesService: SubPeriodTypesService,
    private adminXmlaSubscriptionService: AdminXmlaSubscriptionService,
    private accountService: AccountService,
    private http: HttpClient,
    private dialog: MatDialog,
    public sanitizer: DomSanitizer,
    private settingsService: SettingsService
  ) {
    var currentYear = new Date().getFullYear();
    for (var i = currentYear; i < currentYear + 15; i++) {
      let y = i.toString();
      this.ccAvailableYears.push(y.substr(2, 2));
    }

    this.ccExpirationMonth = this.ccAvailableMonths[0];
    this.ccExpirationYear = this.ccAvailableYears[0];

    this.payPalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      "https://google.com"
    );

    app.getAuthorizationStatus().subscribe((result) => {
      if (!result.isValid) {
        this.app.logOut();
        this.router.navigate(["login"]);
      }
      this.authStatus = result;
    });

    this.route.paramMap.subscribe((params) => {

      this.settingsService.settingsGetSetting('TOS').subscribe(resultUrl => {
        this.baseTosUrl = resultUrl;

        if (params.get("packagetype") == "interactive") {
          this.loadInteractiveData();
        } else if (params.get("packagetype") == "da") {
          this.loadXmlaData();
        } else {
          this.subscriptionType = "Invalid Subscription";
        }
      });
    });
  }

  getSubscriptionPlanName(): string {
    if (this.subscriptionPlanId !== 0) {
      if(this.purchaseType === 'I' && this.allInteractSubTypes) {
        return (this.allInteractSubTypes.find(x => x.interactSubTypeId === this.subscriptionPlanId).interactSubTypeName);
      } else if (this.purchaseType === 'X') {
        return (this.allXmlaSubTypes.find(x => x.xmlaSubscriptionTypeId === this.subscriptionPlanId).xmlaSubscriptionName);
      }
    }
    return '';
  }

  getSubscriptionLevelName(): string {
    if (this.subscriptionLevelId !== 0) {
      if(this.purchaseType === 'I' && this.allInteractSubLevels) {
        return (this.allInteractSubLevels.find(x =>
          x.interactSubTypeId === this.subscriptionPlanId
          && x.interactSubLevelId === this.subscriptionLevelId).description);
      } else if (this.purchaseType === 'X') {
        return (this.allXmlaSubLevels.find(x => x.xmlaSubscriptionLevelId === this.subscriptionLevelId).description);
      }
    }
    return '';
  }

  getSubscriptionPeriodName(): string {
    if (this.subscriptionPeriodId !== 0) {
      if(this.purchaseType === 'I' && this.allInteractPricesTypes) {
        return (this.allInteractPricesTypes.find(x => x.periodTypeId === this.subscriptionPeriodId).periodType.description);
      } else if (this.purchaseType === 'X') {
        return (this.allXmlaSubPrices.find(x => x.periodTypeId === this.subscriptionPeriodId).periodType.description);
      }
    }
    return '';
  }


  loadInteractiveData() {
    this.adminInteractiveSubService
      .adminInteractiveSubGetInteractSubTypes()
      .subscribe((interactSubServiceResult) => {
        this.allInteractSubTypes = interactSubServiceResult;

        this.adminInteractiveSubService
          .adminInteractiveSubGetSubscriptionPrices()
          .subscribe((interactSubPricesResult) => {
            this.allInteractPricesTypes = interactSubPricesResult;

            this.adminInteractiveSubService
              .adminInteractiveSubGetInteractSubLevels()
              .subscribe((interactSubLevelResult) => {
                this.allInteractSubLevels = interactSubLevelResult.filter(
                  (level) => level.allowPurchase
                );

                this.subPeriodTypesService
                  .subPeriodTypesGetSubPeriodTypesAll()
                  .subscribe((periodTypesResult) => {
                    this.allPeriodTypes = periodTypesResult;

                    for (
                      var i = 0;
                      i < this.allInteractPricesTypes.length;
                      i++
                    ) {
                      for (var e = 0; e < this.allPeriodTypes.length; e++) {
                        if (
                          this.allInteractPricesTypes[i].periodTypeId ==
                          this.allPeriodTypes[e].periodTypeId
                        ) {
                          this.allInteractPricesTypes[
                            i
                          ].periodType = this.allPeriodTypes[e];
                        }
                      }
                    }

                    // Remove any subscription types that don't have any levels (so any without levels that are available for purchase)
                    this.allInteractSubTypes = this.allInteractSubTypes.filter(
                      (subType) => {
                        const subLevels = this.allInteractSubLevels.filter(
                          (level) =>
                            level.interactSubTypeId == subType.interactSubTypeId
                        );
                        return subLevels && subLevels.length > 0;
                      }
                    );

                    this.route.paramMap.subscribe((params) => {
                      this.subscriptionType =
                        "Public Insight Interactive Subscription";
                      this.purchaseType = "I";
                      this.subscriptionPlanId = parseInt(
                        params.get("subscriptiontype")
                      );
                      this.updateSubscriptionLevels();
                      var selectedLevel = parseInt(
                        params.get("subscriptionlevel")
                      );
                      if (selectedLevel != 0)
                        this.subscriptionLevelId = selectedLevel;
                      this.updateSubscriptionPeriods();

                      if (
                        params.get("couponCode") != "" &&
                        params.get("couponCode") != null
                      ) {
                        this.couponCode = params.get("couponCode");
                        this.getCouponOrPeriod();
                      }

                      this.doneLoading = true;
                    });
                  });
              });
          });
      });
  }

  loadXmlaData() {
    this.adminXmlaSubscriptionService
      .adminXmlaSubscriptionGetXmlaSubscriptionTypes()
      .subscribe((xmlaSubServiceResult) => {
        this.allXmlaSubTypes = xmlaSubServiceResult;

        this.adminXmlaSubscriptionService
          .adminXmlaSubscriptionGetXmlaSubscriptionPrices()
          .subscribe((xmlaSubPricesResult) => {
            this.allXmlaSubPrices = xmlaSubPricesResult;

            this.adminXmlaSubscriptionService
              .adminXmlaSubscriptionGetXmlaSubscriptionLevelsAll()
              .subscribe((xmlaSubLevelResult) => {
                this.allXmlaSubLevels = xmlaSubLevelResult;

                this.subPeriodTypesService
                  .subPeriodTypesGetSubPeriodTypesAll()
                  .subscribe((periodTypesResult) => {
                    this.allPeriodTypes = periodTypesResult;

                    for (var i = 0; i < this.allXmlaSubPrices.length; i++) {
                      for (var e = 0; e < this.allPeriodTypes.length; e++) {
                        if (
                          this.allXmlaSubPrices[i].periodTypeId ==
                          this.allPeriodTypes[e].periodTypeId
                        ) {
                          this.allXmlaSubPrices[
                            i
                          ].periodType = this.allPeriodTypes[e];
                        }
                      }
                    }

                    this.route.paramMap.subscribe((params) => {
                      this.subscriptionType =
                        "Public Insight Analytical Dataset Subscription";
                      this.purchaseType = "X";
                      this.subscriptionPlanId = parseInt(
                        params.get("subscriptiontype")
                      );
                      this.updateSubscriptionLevels();
                      var selectedLevel = parseInt(
                        params.get("subscriptionlevel")
                      );
                      if (selectedLevel != 0)
                        this.subscriptionLevelId = selectedLevel;
                      this.updateSubscriptionPeriods();

                      if (
                        params.get("couponCode") != "" &&
                        params.get("couponCode") != null
                      ) {
                        this.couponCode = params.get("couponCode");
                        this.getCouponOrPeriod();
                      }

                      this.doneLoading = true;
                    });
                  });
              });
          });
      });
  }

  updateSubscriptionLevels() {
    if (this.purchaseType == "I") {
      for (var i = 0; i < this.allInteractSubTypes.length; i++) {
        if (
          this.allInteractSubTypes[i].interactSubTypeId ==
          this.subscriptionPlanId
        ) {
          this.licenseHtml = this.allInteractSubTypes[i].licenseHtml;
        }
      }

      this.selectedSubLevels = [];
      for (var i = 0; i < this.allInteractSubLevels.length; i++) {
        if (
          this.allInteractSubLevels[i].interactSubTypeId ==
          this.subscriptionPlanId
        ) {
          this.selectedSubLevels.push(this.allInteractSubLevels[i]);
        }
      }
      this.subscriptionLevelId = this.selectedSubLevels[0].interactSubLevelId;
      this.allowInvoice = this.selectedSubLevels[0].allowInvoice;
      this.orderPaymentMethod = "CreditCard";
    } else if (this.purchaseType == "X") {
      for (var i = 0; i < this.allXmlaSubTypes.length; i++) {
        if (
          this.allXmlaSubTypes[i].xmlaSubscriptionTypeId ==
          this.subscriptionPlanId
        ) {
          this.licenseHtml = this.allXmlaSubTypes[i].licenseHtml;
        }
      }

      this.selectedXmlaSubLevels = [];
      for (var i = 0; i < this.allXmlaSubLevels.length; i++) {
        if (
          this.allXmlaSubLevels[i].xmlaSubscriptionTypeId ==
          this.subscriptionPlanId
        ) {
          this.selectedXmlaSubLevels.push(this.allXmlaSubLevels[i]);
        }
      }
      this.subscriptionLevelId = this.selectedXmlaSubLevels[0].xmlaSubscriptionLevelId;
      this.allowInvoice = this.selectedXmlaSubLevels[0].allowInvoice;
      this.orderPaymentMethod = "CreditCard";
    }

    this.updateSubscriptionPeriods();
  }

  updateSubscriptionPeriods() {
    if (this.purchaseType == "I") {
      this.selectedPriceTypes = [];
      for (var i = 0; i < this.allInteractPricesTypes.length; i++) {
        if (
          this.allInteractPricesTypes[i].interactSubTypeId ==
            this.subscriptionPlanId &&
          this.allInteractPricesTypes[i].interactSubLevelId ==
            this.subscriptionLevelId
        ) {
          this.selectedPriceTypes.push(this.allInteractPricesTypes[i]);
        }
      }
      this.subscriptionPeriodId = this.selectedPriceTypes[0].periodTypeId;

      for (var i = 0; i < this.selectedSubLevels.length; i++) {
        if (
          this.selectedSubLevels[i].interactSubLevelId ==
          this.subscriptionLevelId
        ) {
          this.allowInvoice = this.selectedSubLevels[i].allowInvoice;
          this.orderPaymentMethod = "CreditCard";
        }
      }
    } else if (this.purchaseType == "X") {
      this.selectedXmlaSubPrices = [];
      for (var i = 0; i < this.allXmlaSubPrices.length; i++) {
        if (
          this.allXmlaSubPrices[i].xmlaSubscriptionTypeId ==
            this.subscriptionPlanId &&
          this.allXmlaSubPrices[i].xmlaSubscriptionLevelId ==
            this.subscriptionLevelId
        ) {
          this.selectedXmlaSubPrices.push(this.allXmlaSubPrices[i]);
        }
      }
      this.subscriptionPeriodId = this.selectedXmlaSubPrices[0].periodTypeId;

      for (var i = 0; i < this.selectedXmlaSubLevels.length; i++) {
        if (
          this.selectedXmlaSubLevels[i].xmlaSubscriptionLevelId ==
          this.subscriptionLevelId
        ) {
          this.allowInvoice = this.selectedXmlaSubLevels[i].allowInvoice;
          this.orderPaymentMethod = "CreditCard";
        }
      }
    } 

    this.updateSubscriptionPeriod();
  }

  updateSubscriptionPeriod() {
    this.orderPrice = 0;

    if (this.purchaseType == "I") {
      var targetPricing: InteractSubPrice = null;
      for (var i = 0; i < this.selectedPriceTypes.length; i++) {
        if (
          this.selectedPriceTypes[i].periodTypeId == this.subscriptionPeriodId
        ) {
          targetPricing = this.selectedPriceTypes[i];
        }
      }

      this.orderPrice = targetPricing.price;
      this.orderDiscount = 0;
      this.couponCode = "";
      this.couponCodeError = "";
      this.taxRate = targetPricing.taxRate ?? 0;
      this.orderSalesTax = (this.orderPrice - this.orderDiscount) * this.taxRate;
      this.orderTotalDue = this.orderPrice + this.orderSalesTax;

      if (targetPricing.taxRate) {
        this.isTaxable = true;
      }

      if (targetPricing.proposalUrl) {
        this.isProposal = true;
        this.tosUrl = targetPricing.proposalUrl;
      } else {
        this.tosUrl = this.baseTosUrl;
      }
    } else if (this.purchaseType == "X") {
      var xmlaTargetPricing: XmlaSubscriptionPriceEx = null;
      for (var i = 0; i < this.selectedXmlaSubPrices.length; i++) {
        if (
          this.selectedXmlaSubPrices[i].periodTypeId ==
          this.subscriptionPeriodId
        ) {
          xmlaTargetPricing = this.selectedXmlaSubPrices[i];
        }
      }

      this.orderPrice = xmlaTargetPricing.price;
      this.orderDiscount = 0;
      this.couponCode = "";
      this.couponCodeError = "";
      this.orderSalesTax = 0;
      this.orderTotalDue = this.orderPrice;
    } 
  }

  getCouponOrPeriod() {

    if(this.couponCode === '11' || this.couponCode === '31' || this.couponCode === '51' || this.couponCode === '71' || this.couponCode === '91') {
      this.subscriptionPeriodId = Number(this.couponCode);
      this.couponCode = '';
    }
    else {
      this.couponCodeError = "";

      var req: SubscriptionService.SubscriptionGetCouponCodeDiscountParams = {
        couponCode: this.couponCode,
        periodTypeId: this.subscriptionPeriodId,
        subscriptionLevelId: this.subscriptionLevelId,
        subscriptionTypeId: this.subscriptionPlanId,
        subscriptionType: this.purchaseType,
      };

      this.subscriptionService
        .subscriptionGetCouponCodeDiscount(req)
        .subscribe((result) => {
          if (result != 0) {
            if (result == -1) {
              this.orderDiscount = this.orderPrice;
              this.orderTotalDue = 0;
              this.isFreeTrial = true;
            } else {
              this.orderDiscount = result;
              this.orderTotalDue = this.orderPrice - this.orderDiscount;
            }
            this.couponCodeError = "Coupon Applied";
          } else {
            this.couponCodeError = "Invalid Coupon Code";
          }
        });
    }
  }
  /*
  emailChanged() {
    if (this.userEmail.indexOf("@") > 0 && this.userEmail.indexOf(".") > 0) {
      this.app.isExistingEmail(this.userEmail).subscribe((result) => {
        this.isExistingUser = result;
      });
    } else {
      this.isExistingUser = false;
    }
  }
  

  purchaserEmailChanged() {
    if (
      this.purchaserEmail.indexOf("@") > 0 &&
      this.purchaserEmail.indexOf(".") > 0
    ) {
      this.accountService
        .accountGetUserByEmail(this.purchaserEmail)
        .subscribe((result) => {
          if (result != null) {
            this.purchaserAddress1 = result.address1;
            this.purchaserAddress2 = result.address2;
            this.purchaserCity = result.city;
            this.purchaserFirstName = result.firstName;
            this.purchaserLastName = result.lastName;
            this.purchaserOrganizationName = result.company;
            this.purchaserPhone = result.phone;
            this.purchaserState = result.state;
            this.purchaserTitle = result.title;
            this.purchaserZip = result.zipCode;

            this.isExistingPurchaser = true;
          } else {
            this.isExistingPurchaser = false;
          }
        });
    }
  }

  
  userLogin() {
    this.loginErrorMessage = "";

    var loginLocalParams: LoginLocal = {
      email: this.userEmail,
      password: this.password,
    };

    this.accountService.accountLoginLocal(loginLocalParams).subscribe(
      (result) => {
        if (result == null) {
          this.loginErrorMessage = "Invalid Credentials";
        } else {
          if (result.loginStatus != 1) {
            this.loginErrorMessage = result.errorMessage;

            if (result.loginStatus == -3) {
              this.resendFlag = true;
            }
          } else if ((result.loginStatus = 1)) {
            const jwtResult = JSON.parse(result.jwtToken);
            this.app.logIn(
              jwtResult.id,
              jwtResult.auth_token,
              result.isAdmin,
              this.userEmail
            );
            this.app.getAuthorizationStatus().subscribe((result) => {
              this.authStatus = result;
            });
          }
        }
      },
      (error) => {
        this.loginErrorMessage = "Critical Error, Contact Support";
      }
    );
  }

  resendEmailVerification() {
    var params: LoginLocal = {
      email: this.userEmail,
      password: "",
    };

    this.accountService
      .accountResendVerification(params)
      .subscribe((result) => {
        if (result) {
          this.loginErrorMessage =
            "Verification email sent, make sure you check your junk folder.";
          this.resendFlag = false;
        } else {
          this.loginErrorMessage =
            "Failed to resend email, please contact support.";
          this.resendFlag = false;
        }
      });
  }
  */
  validateForm(): boolean {
    var phoneTest = /^(1?(-?\d{3})-?)?(\d{3})(-?\d{4})$/;
    var stateTest = /^((AL)|(AK)|(AS)|(AZ)|(AR)|(CA)|(CO)|(CT)|(DE)|(DC)|(FM)|(FL)|(GA)|(GU)|(HI)|(ID)|(IL)|(IN)|(IA)|(KS)|(KY)|(LA)|(ME)|(MH)|(MD)|(MA)|(MI)|(MN)|(MS)|(MO)|(MT)|(NE)|(NV)|(NH)|(NJ)|(NM)|(NY)|(NC)|(ND)|(MP)|(OH)|(OK)|(OR)|(PW)|(PA)|(PR)|(RI)|(SC)|(SD)|(TN)|(TX)|(UT)|(VT)|(VI)|(VA)|(WA)|(WV)|(WI)|(WY))$/;
    var zipTest = /^[2-9]\d{2}-\d{3}-\d{4}$/;

    if (!this.isFreeTrial) {
      if (
        this.orderPaymentMethod === "CreditCard" &&
        (this.ccNumber == null ||
          this.ccNumber == "" ||
          this.ccExpirationMonth == null ||
          this.ccExpirationYear == null ||
          this.ccCvv == null)
      ) {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Error Processing",
          "CC Number, Expiration Month / Year, and CVV are required."
        );
        return false;
      }

      if (
        this.orderPaymentMethod === "Invoice" &&
        (this.poNumber == null || this.poNumber.trim() == "")
      ) {
        if (!this.isFreeTrial) {
          MessageDialogComponent.showDialog(
            this.dialog,
            "Error Processing",
            "PO Number is Required"
          );
          return false;
        }
      }
    }

    if (!this.licenseAgree) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error Processing",
        "You must agree to the license terms."
      );
      return false;
    }

    if (this.poNumber.length > 20) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error Processing",
        "PO must not exceed 20 characters."
      );
      return false;
    }

    /*
    if (!this.isExistingUser && !this.authStatus.isValid) {
      if (this.userEmail === null || this.userEmail.trim() === "") {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Error Processing",
          "Email Address Required"
        );
        return false;
      }

      if (this.userEmail != this.reEnterUserEmail) {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Error Procesing",
          "Email Addresses do not Match."
        );
        return false;
      }

      if (this.password === null || this.password.trim() === "") {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Error Processing",
          "Password cannot be blank."
        );
        return false;
      }

      if (this.password !== this.confirmPassword) {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Error Processing",
          "Passwords do not match."
        );
        return false;
      }

      if (!phoneTest.test(this.phone)) {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Error Processing",
          "Phone Number In Wrong Format or Missing"
        );
        return false;
      }

      if (!stateTest.test(this.state.toUpperCase()) || this.state.length > 2) {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Error Processing",
          "State Invalid, Use 2 character state abbreviation"
        );
        return false;
      }
    }
    */
    /*if (!this.userIsBuyer && !this.isExistingPurchaser) {
      if (this.purchaserEmail === null || this.purchaserEmail.trim() === "") {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Error Processing",
          "Purchaser Email Address Required"
        );
        return false;
      }

      if (!phoneTest.test(this.purchaserPhone)) {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Error Processing",
          "Purchaser Phone Number In Wrong Format or Missing"
        );
        return false;
      }

      if (!stateTest.test(this.purchaserState.toUpperCase()) || this.purchaserState.length > 2) {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Error Processing",
          "Purchaser State Invalid, Use 2 character state abbreviation"
        );
        return false;
      }

      if(this.organizationName.trim().length === 0) {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Error Processing",
          "Organization Required."
        );
        return false;
      }
    }*/

    return true;
  }

  processPayment() {
    if (this.validateForm()) {
      var purchaseDetail: SubscriptionPurchaseViewModel = {
        autoRenew: this.autoRenew,
        addressLine1: this.addressLine1,
        addressLine2: this.addressLine2,
        licenseAgree: true,
        purchaserAddress1: this.purchaserAddress1,
        purchaserAddress2: this.purchaserAddress2,
        levelId: this.subscriptionLevelId,
        periodId: this.subscriptionPeriodId,
        planId: this.subscriptionPlanId,
        taxExempt: this.taxExempt === "Yes",
        city: this.city,
        couponCode: this.couponCode,
        firstName: this.firstName,
        lastName: this.lastName,
        orderPaymentMethod: this.orderPaymentMethod,
        organizationName: this.organizationName,
        poNumber: this.poNumber,
        purchaserCity: this.purchaserCity,
        purchaserEmail: this.purchaserEmail,
        purchaserFirstName: this.purchaserFirstName,
        purchaserLastName: this.purchaserLastName,
        purchaserOrganizationName: this.purchaserOrganizationName,
        purchaserPhone: this.purchaserPhone,
        purchaserState: this.purchaserState,
        purchaserTitle: this.purchaserTitle,
        purchaserZip: this.purchaserZip,
        purchaseType: this.purchaseType,
        state: this.state,
        taxExemptExpirationDate: this.taxExemptExpirationDate,
        taxExemptNumber: this.taxExemptNumber,
        title: this.title,
        zip: this.zip,
        userIsBuyer: this.userIsBuyer,
        nonConsumer: this.nonConsumer,
        emailAddress: this.userEmail,
        password: this.password,
        phone: this.phone,
      };

      this.processingCreditCard = true;

      this.subscriptionService
        .subscriptionPurchaseSubscription(purchaseDetail)
        .subscribe(
          (trackingId) => {
            if (!trackingId.success) {
              console.log(trackingId.errorMessage);
            } else {
              if (this.orderPaymentMethod === "Invoice" || this.isFreeTrial) {
                this.donePurchasing = true;
              } else {
                var fullUrl =
                  trackingId.requestUrl +
                  "&ACCT=" +
                  this.ccNumber +
                  "&EXPDATE=" +
                  this.ccExpirationMonth +
                  this.ccExpirationYear +
                  "&CVV2" +
                  this.ccCvv;
                this.payPalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                  fullUrl
                );
                //var payPalWindow = window.open(fullUrl, '_blank');

                var trackWait = interval(5000).subscribe((val) => {
                  this.subscriptionService
                    .subscriptionTrackSubscriptionPayment(trackingId)
                    .subscribe((trackingResult) => {
                      if (trackingResult.completed) {
                        this.processingCreditCard = false;
                        trackWait.unsubscribe();
                        //payPalWindow.close();

                        if (trackingResult.success) {
                          this.donePurchasing = true;
                        } else {
                          MessageDialogComponent.showDialog(
                            this.dialog,
                            "Error Processing",
                            trackingResult.errorMessage
                          );
                        }
                      }
                    });
                });
              }
            }
          },
          (error) => {
            console.log(error);
            this.processingCreditCard = false;
          }
        );
    }
  }

  launchLicenseHtml(): boolean {
    if (this.licenseHtml != "") {
      HtmlMessageDialogComponent.showDialog(
        this.dialog,
        "License Agreement",
        this.licenseHtml
      ).subscribe((result) => {});
    }

    return false;
  }

  /*loadSubscriptions(): void {

    this.subscriptionService.subscriptionGetManagedSubscriptions().subscribe(result => {
      if (result.length > 0) {
        this.userSubscriptions = result;
      } else {
      }
    }, error => {
        var t = 0;
    });
  }*/

  /*loadSubscriptionDetails(subscriptionId: number): boolean {
    var queryStringParams = {
      subscriptionId: subscriptionId
    };

    this.router.navigate(['subscriptionmanagement', queryStringParams.subscriptionId]);

    return false;
  }*/
}
